import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { useTrackingsActions } from '@bluheadless/ui-logic/src/hooks/trackings'
import { useUser } from '@bluheadless/ui-logic/src/providers/user'
import { useUserUniqueId } from '@bluheadless/ui-logic/src/hooks/useUserUniqueId'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useEffect } from 'react'
import { usePageContext } from '@bluheadless/ui-logic/src/providers/page/page'

const ProductTrackings = () => {
	const { pageViewDetails } = useTrackingsActions()
	const { entityType: pageContext, __bhEntityId: pageId } = usePageContext()
	const [{ isLoggedIn }] = useUser()

	const userUniqueId = useUserUniqueId()
	const { locale } = useConfig()

	const [{ product, configurableChildrenProducts, groupedChildrenProducts, bundleProducts, loading }] =
		useProductContext()

	useEffect(() => {
		if (!userUniqueId || loading) {
			return
		}
		pageViewDetails({
			pageType: 'product',
			params: {
				isLoggedIn,
				userUniqueId,
				locale,
				entityId: product.id,
				...product,
				configurableChildrenProducts,
				groupedChildrenProducts,
				bundleProducts,
			},
			pageContext,
			pageId,
		})
	}, [
		isLoggedIn,
		userUniqueId,
		pageViewDetails,
		locale,
		product,
		configurableChildrenProducts,
		groupedChildrenProducts,
		bundleProducts,
		loading,
		pageContext,
		pageId,
	])

	return null
}

ProductTrackings.propTypes = {}

export default ProductTrackings
